<template>
  <div class="container">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item class="black">{{
        t("customermanagement")
      }}</a-breadcrumb-item>
      <a-breadcrumb-item class="currentrouter">{{
        t("userlist")
      }}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="search-input-group">
      <a-input
        style="width: 15%"
        v-model:value="userList.keyword"
        :placeholder="t('enterphoneusername')"
      />
      <a-button type="primary" class="searchBtn" @click="hadnleSearch">{{
        t("search")
      }}</a-button>
      <a-button type="primary" class="searchBtn addBtn" @click="addUser">{{
        t("newuser")
      }}</a-button>
    </div>
    <a-table
      :dataSource="dataSource"
      :columns="columns"
      :pagination="false"
      :scroll="{ y: maxHeight, x: 2000 }"
    >
      <template v-slot:bodyCell="{ text, record, column }">
        <template v-if="column.title === t('customer')">
          {{ rearrangement(text) }}</template
        >
        <template v-if="column.title === t('state')">
          {{ text === "0" ? t("enable") : t("disable") }}</template
        >
        <template v-if="column.title === t('userrole')">
          {{ text ? text.role_name : "" }}</template
        >
        <template v-if="column.title === t('messageswitch')">
          {{ text === "0" ? t("off") : t("on") }}</template
        >
        <template v-if="column.title === t('dutyhours')">
          {{ record.duty_start + "-" + record.duty_end }}</template
        >
        <template v-if="column.title === t('customertype')">
          {{
            record.type == "2" ? t("domesticusers") : t("internationalusers")
          }}</template
        >
        <template v-if="column.title === t('operate')">
          <div class="operate">
            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link" @click="checkItem(record)">
                <img
                  v-if="record.id !== checkedId"
                  src="../assets/images/notclicked.png"
                  alt=""
                />
                <img v-else src="../assets/images/clicked.png" alt="" />
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item key="0" @click="editUser(record.id)">
                    {{ t("edit") }}</a-menu-item
                  ><a-menu-divider />
                  <a-menu-item
                    key="1"
                    @click="changeStatus(record.id, record.is_del)"
                    >{{
                      record.is_del === "0" ? t("disable") : t("enable")
                    }}</a-menu-item
                  ><a-menu-divider />
                  <a-menu-item key="2" @click="resetPasswd(record.id)">{{
                    t("resetpassword")
                  }}</a-menu-item>
                  <a-menu-divider />
                  <a-menu-item key="3" @click="goCarList(record.id)">{{
                    t("vehiclelist")
                  }}</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </template>
      </template>
    </a-table>
    <a-pagination
      class="pagination"
      show-size-changer
      show-quick-jumper
      :show-total="(totalNum) => `${t('intotal')} ${totalNum} ${t('article')}`"
      v-model:current="userList.page"
      v-model:pageSize="userList.size"
      :total="totalNum"
      size="small"
      @change="handlePaginationChange"
    />
  </div>
</template>
<script>
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import routerName from "@/router/routerName";
import { Modal, message } from "ant-design-vue";
import { onMounted, ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const maxHeight = computed(() => store.getters.getMaxHeight);
    const dataSource = ref();
    const totalNum = ref(0);
    const userList = ref({
      keyword: "",
      page: 1,
      size: 10,
    });
    const router = useRouter();
    const getListData = () => {
      Api.getUserList(userList.value).then((res) => {
        if (res.err_no == ResultCodeType.success_200) {
          dataSource.value = res.result;
          totalNum.value = Number(res.total_num);
        } else {
          message.error(res.err_msg);
        }
      });
    };
    const handlePaginationChange = (page, pageSize) => {
      userList.value.page = page;
      userList.value.size = pageSize;
      getListData();
    };
    const handleSearchInput = () => {
      getListData();
    };
    const hadnleSearch = () => {
      userList.value.page = 1;
      getListData();
    };
    const addUser = () => {
      router.push({ path: routerName.userCreate, params: {} });
    };
    const rearrangement = (val) => {
      let nameList = "";
      if (val.length > 0) {
        val.forEach((item) => {
          nameList = nameList + (nameList.length > 0 ? " , " : "") + item;
        });
        return nameList;
      } else {
        return "";
      }
    };
    const chenge = (id) => {
      Api.changeUser({ id }).then((value) => {
        if (value.err_no == ResultCodeType.success_200) {
          getListData();
          message.success(t("changesuccessful"));
        } else {
          message.error(t("changefailed"));
        }
      });
    };
    const changeStatus = (userId, status) => {
      if (status === "0") {
        Modal.confirm({
          title: t("confirmdisable"),
          centered: true,
          okText: t("determine"),
          onOk() {
            const id = userId;
            return new Promise((resolve) => {
              chenge(id);
              resolve();
            }).catch(() => console.log("Oops errors!"));
          },
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onCancel() {},
        });
      } else {
        chenge(userId);
      }
    };
    const resetPasswd = (id) => {
      const params = {
        id: id,
      };
      Api.resetPasswd(params).then((val) => {
        if (val.err_no == ResultCodeType.success_200) {
          message.success(t("passwordresetto") + "：idriverplus");
          getListData();
        } else {
          message.error(val.err_msg);
        }
      });
    };
    const goCarList = (id) => {
      router.push({ path: routerName.uservehiclelist, query: { id } });
    };
    const editUser = (id) => {
      router.push({
        path: routerName.userCreate,
        query: { id: id, isEdit: 1 },
      });
    };
    const checkedId = ref("");
    const checkItem = (value) => {
      checkedId.value = value.id;
    };
    onMounted(() => {
      getListData();
    });
    return {
      checkItem,
      checkedId,
      dataSource,
      columns: [
        {
          title: t("mobilephone"),
          dataIndex: "phone",
          key: "phone",
          align: "center",
          width: 150,
        },
        {
          title: t("username"),
          dataIndex: "username",
          key: "username",
          align: "center",
          width: 100,
        },
        {
          title: t("customer"),
          dataIndex: "orgname",
          key: "orgname",
          align: "center",
        },
        {
          title: t("state"),
          dataIndex: "is_del",
          key: "is_del",
          align: "center",
          width: 100,
        },
        {
          title: t("agent"),
          dataIndex: "createTime",
          key: "createTime",
          align: "center",
          width: 100,
        },
        {
          title: t("userrole"),
          dataIndex: "roles",
          key: "roles",
          align: "center",
          width: 100,
        },
        {
          title: t("messageswitch"),
          dataIndex: "message_switch",
          key: "message_switch",
          align: "center",
          width: 150,
        },
        {
          title: t("dutyhours"),
          dataIndex: "zbsj",
          key: "zbsj",
          align: "center",
        },
        {
          title: t("responsibleforthenumberofvehicles"),
          dataIndex: "vehicle_num",
          key: "vehicle_num",
          align: "center",
          width: 200,
        },
        {
          title: t("customertype"),
          dataIndex: "roles",
          key: "roles",
          align: "center",
        },
        {
          title: t("usercomments"),
          dataIndex: "remark",
          key: "remark",
          align: "center",
        },
        {
          title: t("founder"),
          dataIndex: "creator_name",
          key: "creator_name",
          align: "center",
        },
        {
          title: t("creationtime"),
          dataIndex: "created",
          key: "created",
          align: "center",
        },
        {
          title: t("operate"),
          dataIndex: "operate_status",
          key: "operate_status",
          width: 100,
          align: "center",
        },
      ],
      userList,
      handlePaginationChange,
      hadnleSearch,
      handleSearchInput,
      totalNum,
      addUser,
      goCarList,
      rearrangement,
      editUser,
      changeStatus,
      resetPasswd,
      maxHeight,
      t,
    };
  },
};
</script>
<style scoped></style>
